import React, { useState } from "react";

const FAQsPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    if (openIndex === index) {
      setOpenIndex(null); // Close the currently open item
    } else {
      setOpenIndex(index); // Open the clicked item
    }
  };

  const faqs = [
  {
    question: "What is Smart Chokidar, and how does it improve the lives of inhabitants?",
    answer: "Smart Chokidar is a cooperative society management software that aims to increase security, communication, and efficiency in residential societies. It makes visitor tracking easy, organizes tasks in an efficient manner, and facilitates smooth communication between residents and the management committee. With real-time updates, transparency, and hassle-free access to services, Smart Chokidar greatly enhances the quality of life for residents.",
  },
  {
    question: "What key functionalities does Smart Chokidar offer?",
    answer: "Smart Chokidar provides essential features like live visitor management, easy entry authorization, and tracking. It also provides communication through forums, announcements, and discussion between residents and the management. Smart Chokidar also makes maintenance fee tracking, emergency alerts, and facility bookings easier, thus making it more efficient and secure to manage a community.",
  },
  {
    question: "How does Smart Chokidar bridge the gap between residents and their management committee?",
    answer:
      "Smart Chokidar bridges the gap between residents and the management committee by offering seamless communication tools such as forums, announcements, and discussion boards. It allows residents to raise concerns, provide feedback, and stay informed about community updates. The management committee can respond in real time, ensuring transparency, faster resolutions, and better engagement between both parties.",
  },
  {
    question: "What features make Smart Chokidar the top choice for cooperative societies?",
    answer: "Smart Chokidar is the best option for cooperative societies because of its all-encompassing features, such as secure visitor management, real-time notifications, and simple maintenance fee tracking. It also provides streamlined communication features, like forums and announcements, and makes task management for the committee easy. These features provide a safe, organized, and transparent community setting.",
  },
  {
    question: "What tools in Smart Chokidar help residents stay informed about events and activities?",
    answer: "Smart Chokidar keeps residents updated about events and activities with features such as real-time alerts, community notices, and event calendars. It enables the management committee to make announcements, share news, and remind residents of upcoming events or significant activities, keeping everyone connected and updated.",
  },
  {
    question: "How is Smart Chokidar able to keep privacy and enable communication within the community?",
    answer: "Smart Chokidar preserves privacy by providing secure, encrypted communication channels for residents and the management committee. It keeps personal information and conversations confidential, with access controls that restrict visibility to authorized users only. Residents can also communicate in private forums or groups, preserving privacy while fostering community interaction.",
  },
  {
    question: "What tools does Smart Chokidar offer to ease the workload of managing residential communities?",
    answer: "Smart Chokidar provides features such as automated tracking of maintenance fees, visitor management, and facility reservations to simplify the task of running residential communities. It also has streamlined communication functionalities, including announcements, forums, and real-time alerts, that reduce administrative work and enhance efficiency for the management committee.",
  },
  {
    question: "What features in society software improve visitor management and ensure better security?",
    answer: "Society software such as Smart Chokidar enhances visitor management and security through features like real-time tracking of visitors, pre-authorization of guests, and entry logs. It also provides secure access control by enabling residents to approve visitors remotely, so only authorized persons can gain entry. The software also offers alerts for suspicious activity, which enhances overall community safety.",
  },
  ];

  return (
    <section id="faqs">
      <div className="bg-white p-6 2xl:px-40 xl:px-40 l:px-40 md:px-40 sm:px-20 xs:px-20 rounded-lg shadow-md">
        <h1 className="text-3xl md:text-4xl font-bold mb-6 text-center">
          Frequently Asked Questions
        </h1>
        <div className="flex flex-col gap-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg p-4"
              style={{ transition: "height 0.3s ease" }}
            >
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleAnswer(index)}
              >
                <h3 className="font-semibold">{faq.question}</h3>
                <button className="text-xl">
                  {openIndex === index ? "×" : "+"}
                </button>
              </div>
              {openIndex === index && (
                <p className="mt-2 text-gray-700">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQsPage;
